export default {
	UPDATE_ANSWERS: "UPDATE_ANSWERS",
	UPDATE_ANSWER: "UPDATE_ANSWER",
	CREATE_ANSWER: "CREATE_ANSWER",
	DELETE_ANSWER: "DELETE_ANSWER",
	RESET_ANSWERS: "RESET_ANSWERS",
	CLEAR_STORE_ANSWERS: "CLEAR_STORE_ANSWERS"
};

export const RICH_ANSWER_FORMATS = [
	"menu",
	"document",
	"link",
	"location",
	"locationRequest",
	"contact",
	"richtext"
];
